import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import PublishIcon from '@material-ui/icons/Publish';
import { CircularProgress } from '@material-ui/core';
import { useRef } from 'react';
 
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
 
export default function ImportFile({ label, onFileChange, isLoading = false, isDisabled = false }) {
  const inputRef = useRef(null);
 
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      onFileChange(e.target.files[0]);
      inputRef.current.value = '';
    }
  };
 
  return (
    <Button
      component="label"
      variant="contained"
      sx={{
        backgroundColor: 'rgb(46, 125, 50)',
        '&:hover': {
          backgroundColor: 'rgb(27, 94, 32) !important',
          color: '#FFFFFF !important',
        },
      }}
      startIcon={<PublishIcon />}
      disabled={isDisabled}>
      {label}
      <VisuallyHiddenInput type="file" ref={inputRef} onChange={handleFileChange} />
      {isLoading && <CircularProgress color="inherit" thickness={5} size={20} sx={{ ml: 1 }} />}
    </Button>
  );
}
 
ImportFile.propTypes = {
  label: PropTypes.string,
  onFileChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};